import { z } from "zod";

export const projectSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(1, { message: "Le titre est obligatoire" }),
  description: z
    .string({ required_error: "La description est obligatoire" })
    .min(1, { message: "La description  est obligatoire" }),
  date_debut: z.date({
    required_error: "La date de début est obligatoire",
  }),
  date_fin: z.date({
    required_error: "La date de fin est obligatoire",
  }),

  //status: z.string().min(1, { message: "Le status est obligatoire" }),
});

export type ProjectFormValues = z.infer<typeof projectSchema>;

export const updateProjectSchema = z
  .object({
    title: z.string().min(1, { message: "Le titre est obligatoire" }),
    description: z
      .string()
      .min(1, { message: "La description  est obligatoire" }),
    date_debut: z.date({
      required_error: "La date est obligatoire",
    }),
    date_fin: z.date({
      required_error: "La date est obligatoire",
    }),
  })
  .partial();

export type UpdateProjectFormValues = z.infer<typeof updateProjectSchema>;
